export type LOCALE_TYPE =
  | 'bg-BG'
  | 'de-DE'
  | 'en-PK'
  | 'en-US'
  | 'en-ES'
  | 'es-ES'
  | 'fr-FR'
  | 'hr-HR'
  | 'hu-HU'
  | 'it-IT'
  | 'nl-NL'
  | 'pt-PT'
  | 'ro-MD'
  | 'ro-RO'
  | 'rs-RS'
  | 'ru-KZ'
  | 'sr-RS'
  | 'tr-TR'
  | 'uk-UA'
  | 'pl-PL'
  | 'sk-SK'
  | 'cs-CZ'
  | 'de-AT';

export const FALLBACK_LOCALE: LOCALE_TYPE = 'en-US';

export const LANGUAGE_TO_LOCALE_MAP: { [key: string]: LOCALE_TYPE } = {
  bg: 'bg-BG',
  'bg-bg': 'bg-BG',
  de: 'de-DE',
  'de-de': 'de-DE',
  en: 'en-US',
  'en-pk': 'en-PK',
  'en-us': 'en-US',
  'en-es': 'en-ES',
  es: 'es-ES',
  'es-es': 'es-ES',
  fr: 'fr-FR',
  'fr-fr': 'fr-FR',
  hr: 'hr-HR',
  'hr-hr': 'hr-HR',
  hu: 'hu-HU',
  'hu-hu': 'hu-HU',
  it: 'it-IT',
  'it-it': 'it-IT',
  nl: 'nl-NL',
  'nl-nl': 'nl-NL',
  pt: 'pt-PT',
  'pt-pt': 'pt-PT',
  ro: 'ro-RO',
  'ro-ro': 'ro-RO',
  mo: 'ro-MD',
  'ro-md': 'ro-MD',
  rs: 'rs-RS',
  'rs-rs': 'rs-RS',
  kk: 'ru-KZ',
  'ru-kz': 'ru-KZ',
  sr: 'sr-RS',
  'sr-rs': 'sr-RS',
  tr: 'tr-TR',
  'tr-tr': 'tr-TR',
  uk: 'uk-UA',
  'uk-ua': 'uk-UA',
  pl: 'pl-PL',
  'pl-pl': 'pl-PL',
  sk: 'sk-SK',
  'sk-sk': 'sk-SK',
  cs: 'cs-CZ',
  'cs-cz': 'cs-CZ',
  at: 'cs-CZ',
  'de-at': 'de-AT',
};

const getBrowserLanguage = (): string | void => {
  const knownLanguageList = navigator.languages
    ?.filter((lang) => !!LANGUAGE_TO_LOCALE_MAP[lang.toLowerCase()])
    .map((lang) => lang.toLocaleLowerCase());

  return (knownLanguageList && knownLanguageList[0]) || navigator.language;
};

export const getLocale = (): LOCALE_TYPE => {
  const language = getBrowserLanguage();
  return LANGUAGE_TO_LOCALE_MAP[language || FALLBACK_LOCALE.toLowerCase()];
};
